import request from './axios'
import requestSec from './axiosSec'

// // 退出登录
// export const logout = (data) => requestSec({
//   url: '/sso/logout',
//   method: 'post',
//   data: data
// })

// 20250106 新增获取当前平台ticketexport const getTicket = (data) => requestSec({  url: 'sso/getTicket',  method: 'post',  data: data})
// 20241205 新增 调用本系统退出登录
export const logout = data => request({
	url: 'user/logout',
	method: 'post',
	data: data
})

// 微信解绑
export const unBindAllTest = (params) => requestSec({
  url: '/user/internal/alksdjflkajdklfjdsakl',
  method: 'get',
  params: params
})

// 获取验证码
export const getCaptcha = (data) => request({
  url: '/captcha/get',
  method: 'post',
  data: data,
  type: 1
})

// 微信绑定
export const wechatBind = (data) => request({
  url: '/user/wechatBind',
  method: 'post',
  data: data,
  type: 1
})

// 注册
export const register = (data) => request({
  url: '/user/register',
  method: 'post',
  data: data
})

// 登录
export const login = (data) => request({
  url: '/user/login',
  method: 'post',
  data: data,
  type: 1
})

// 找回锐享ID
export const retrieveEmail = (data) => request({
  url: '/user/retrieveEmail',
  method: 'post',
  data: data
})

// 手机号找回密码
export const resetPasswordByTelephone = (data) => request({
  url: '/user/resetPasswordByTelephone',
  method: 'post',
  data: data
})

// 邮箱找回密码
export const resetPasswordByEmail = (data) => request({
  url: '/user/resetPasswordByEmail',
  method: 'post',
  data: data
})

// 修改密码
export const resetPassword = (data) => request({
  url: '/user/resetPassword',
  method: 'post',
  data: data
})

// 修改密码-老密码
export const resetPasswordByOldPassword = (data) => request({
  url: '/user/changePassword',
  method: 'post',
  data: data
})

// 修改个人信息
export const changeInformation = (data) => request({
  url: '/user/updateInfo',
  method: 'post',
  data: data
})

// 修改账号
export const changeUsername = (data) => request({
  url: '/user/changeUsername',
  method: 'post',
  data: data
})

// 获取收件地址
export const getAddress = (data) => request({
  url: '/user/address/getDefaultAddress',
  method: 'post',
  data: data
})

// 设置收件地址
export const setAddress = (data) => request({
  url: '/user/address/createAddress',
  method: 'post',
  data: data
})

// 编辑地址
export const updateAddress = (data) => request({
  url: '/user/address/updateAddress',
  method: 'post',
  data: data
})

// 注册时保存的地址
export const setWithoutLoginAddress = (data) => request({
  url: '/user/mailAddress/setWithoutLogin',
  method: 'post',
  data: data
})

// 判断当前登陆是否有效
export const checkLogin = (data) => request({
  url: '/user/checkLogin',
  method: 'post',
  data: data
})

// 上传文件
export const uploadSave = (data) => request({
  url: '/upload/save',
  method: 'post',
  data: data
})

// 获取用户信息
export const getUserInfo = (data) => request({
  url: '/user/getInfo',
  method: 'post',
  data: data,
  type: 1
})

// 获取统一登录的token
export const getToken = (data) => request({
  url: '/user/ticketLogin',
  method: 'post',
  data: data,
  type: 1
})



// WEBPACK FOOTER //
// ./src/api/api.js